module.exports = __webpack_public_path__ + "static/media/TimeTravelClue3.c7a87502.png";